import type { StockListResult, StockRow } from './types';

class SelectionLimitError extends Error {
  messageSource = 'Die Auswahl umfasst {total} Artikel. Höchstens {limit} Artikel können übernommen werden. Bitte die Suche eingrenzen.';
  messageParameters: Record<string, number>;
  constructor(total: number, limit: number) {
    super(`Die Auswahl umfasst ${total} Artikel. Höchstens ${limit} Artikel können übernommen werden. Bitte die Suche eingrenzen.`);
    this.messageParameters = { total, limit };
  }
}

/** Resolve the complete filtered selection before a caller can mutate its document. */
export async function loadFilteredStockRows(
  fetchPage: (skip: number, take: number) => Promise<StockListResult>,
  selectionLimit: number,
  signal: AbortSignal,
): Promise<StockRow[]> {
  if (!Number.isSafeInteger(selectionLimit) || selectionLimit < 0) throw new Error('Ungültige Grenze für die Artikelauswahl.');
  const matching: StockRow[] = [];
  const identities = new Set<string>();
  let expected: number | undefined;
  do {
    signal.throwIfAborted();
    const result = await fetchPage(matching.length, 500);
    signal.throwIfAborted();
    if (result.total > selectionLimit) throw new SelectionLimitError(result.total, selectionLimit);
    if (expected !== undefined && result.total !== expected) throw new Error('Die Treffer wurden während der Auswahl geändert. Bitte erneut auswählen.');
    expected = result.total;
    for (const item of result.items) {
      const identity = String(item.ID ?? item.STOK_KOD ?? '');
      if (identities.has(identity)) throw new Error('Die Treffer wurden während der Auswahl geändert. Bitte erneut auswählen.');
      identities.add(identity); matching.push(item);
    }
    if (matching.length > expected || (result.items.length === 0 && matching.length < expected)) throw new Error('Die Treffer konnten nicht vollständig geladen werden. Bitte erneut auswählen.');
  } while (matching.length < expected);
  if (matching.length === 0) throw new Error('Keine Artikel mehr gefunden. Bitte die Suche aktualisieren.');
  return matching;
}
